// Shared by presentation and server-side contract tests. Captured assignment
// evidence is mandatory: old archives must not borrow today's Participants.
import { PROJECT_TRACK_KEYS } from "./projectTracks.js";
export const CANONICAL_WEEKLY_TRACKS = PROJECT_TRACK_KEYS;

const time = value => Number.isFinite(Date.parse(value)) ? Date.parse(value) : 0;

export function weeklyTrackState(project, trackKey) {
  const lines = (project?.lines || []).filter(line => line.trackKey === trackKey);
  const status = (project?.statuses || []).find(row => row.trackKey === trackKey);
  const response = (project?.trackResponses || []).find(row => row.trackKey === trackKey);
  const reported = lines.length > 0 || Boolean(status?.status);
  const reportTime = Math.max(0, time(status?.setAt), time(status?.reportAt), ...lines.flatMap(line =>
    [time(line.createdAt), ...(line.corrections || []).map(c => time(c.createdAt))]));
  // A deliberate quiet response supersedes older evidence without erasing it.
  // A subsequent report/correction or explicit return restores reporting.
  const quiet = response?.response === "quiet" && time(response.createdAt) >= reportTime;
  return { trackKey, state: quiet ? "quiet" : reported ? "reported" : "not_yet",
    status: status?.status || null, response: response || null };
}

export function assignedTrackCompleteness(project) {
  if (!Array.isArray(project?.assignedTrackKeys)) return { available: false, tracks: [], total: null, inCount: null, quietCount: null };
  const assigned = new Set(project.assignedTrackKeys);
  const tracks = CANONICAL_WEEKLY_TRACKS.filter(key => assigned.has(key)).map(key => weeklyTrackState(project, key));
  return { available: true, tracks, total: tracks.length,
    inCount: tracks.filter(row => row.state !== "not_yet").length,
    quietCount: tracks.filter(row => row.state === "quiet").length };
}
